import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import APIUrls from "../../services/APIUrls";
import Select, { components, } from "react-select";
import { getAxiosResponse, postAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import Constants from "../../Constants";
import { dateConvertToTimeStamp, transformBlankToNull } from "../../services/Util";
import jQuery from "jquery";
import { useSelector } from "react-redux";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../components/SuccessMessage";
import $ from "jquery";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import FileDragUpload from "../../components/global/FileDragUpload";
import ErrorMessage from "../../components/ErrorMessage";

export default function MachineTranslation() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  const [projectowners, setProjectowners] = useState([])
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const LoggedInUserId = custBootstrapDataRedux?.user?.userId

  const [departments, setDepartments] = useState([]);
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [selectedDepatment, setSelectedDepartment] = useState([]);
  const [selectedDepatmentv3, setSelectedDepartmentv3] = useState([]);

  const [selectedDepatmentibm, setSelectedDepartmentibm] = useState([]);
  const [selectedDepatmentlilt, setSelectedDepartmentlilt] = useState([]);
  const [selectedDepatmentlWeaver, setSelectedDepartmentWeaver] = useState([]);

  const [preference, setPreference] = useState();
  const [access,setAccess] =useState();

  const [liltTranslate, setLiltTranslate] = useState();
  const [languageWeaverTranslate, setlanguageWeaverTranslate] = useState();
  const [ibmTranslate, setIbmTranslate] = useState();
  const [googleTranslate, setGoogleTranslate] = useState();
  const [microsoftTranslate, setMicrosoftTranslate] = useState();
  const [microsoftTranslatev3, setMicrosoftTranslatev3] = useState();
  const [message, setMessage] = useState(Constants.BLANK);
  const [errorMessage, setErrorMessage] = useState(Constants.BLANK);

  const [clientSecret, setClientSecret] = useState();
  const [departmentModel, setDepartmentModel] = useState([])

  const [microsoftv3, setMicrosoftv3] = useState()

  const [ibmcred, setIbmcred] = useState();
  const [liltapikey, setLiltapikey] = useState()
  const [globalOverlay, showGlobalOverlay] = useState(false);
  const [languageWeaverClientID, setlanguageWeaverClientID] = useState("")
  const [languageWeaverClientSecret, setlanguageWeaverClientSecret] = useState("")

  const selectRef = useRef(null);
  const multiSelectRef = useRef(null);
  const uploadFileRef = useRef(null);
  const[disableUpload, setDisableUpload] = useState(true);


  const updateMessage="Machine Translation Settings successfully updated ";
  const failureMessage="Unable to update machine translation settings. ";

  const translate = t;
  const showModel = (data) => {
    setDepartmentModel(data)
    document.body.classList.add("modal-open");
  };
  const hideModel = () => {
    document.body.classList.remove("modal-open");
  };


  const engineOptions = [{
    "label": "Statistical",
    "value": "statistical"
  },
  {
    "label": "Neural",
    "value": "neural"
  }
  ]
  const updateMicrosoftTranslate = () => {
    if(microsoftTranslate!==undefined && access && preference==='MICROSOFT_TRANSLATE')
    {
      microsoftTranslate["credentialsType"] = "MICROSOFT_TRANSLATE";
      microsoftTranslate["secretCredentials"] = ["CLIENT_SECRET"]
      microsoftTranslate["credentials"] = {
        "CLIENT_SECRET": clientSecret
      }
      if (selectedDepatment && selectedDepatment.length > 0) {
        let userGroups = selectedDepatment.map(id => {
          return {
            "id": id
          }
        })
        microsoftTranslate["userGroups"] = userGroups;
      }
      else {
        microsoftTranslate["userGroups"] = [];
      }
      var isPost=false;
      if (microsoftTranslate?.id===null || microsoftTranslate?.id==='') {
        isPost=true;
     }

      const url = `${APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED('MICROSOFT_TRANSLATE')}`;
      showGlobalOverlay(true); 
  
      putOrPostAxiosResponse(url, microsoftTranslate,isPost).then((res) => {
        if (res?.data?.code === 200  ) {
          if(res.data.data.statusCodeValue===200){
            setMessage(updateMessage)
          }
          else{
            setMessage(failureMessage)
          }
           getSharedCredentials(Constants.MICROSOFT_TRANSLATE);
        }
        showGlobalOverlay(false);
        setTimeout(() => {
          setMessage(Constants.BLANK);
      }, 2000);
      }).catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
    }
    else{
      setMessage(translate("cust_vendor.machine_translation_permission"));
      setTimeout(() => {
        setMessage(''); 
    }, 2000); 
    }
  }

  const updateMicrosoftTranslateV3 = () => {
    if(microsoftTranslatev3!==undefined && access && preference==='MICROSOFT_TRANSLATE_V3')
    {
      microsoftTranslatev3["credentialsType"] = "MICROSOFT_TRANSLATE_V3";
      microsoftTranslatev3["credentials"] = {
        "CLIENT_SECRET": microsoftv3?.clientSecret,
        "DEFAULT_ENGINE": microsoftv3?.defaultEngine,
        "LANGUAGE_PAIR": microsoftv3?.languagePair
      }
      if (selectedDepatmentv3 && selectedDepatmentv3.length > 0) {
        let userGroups = selectedDepatmentv3.map(id => {
          return {
            "id": id
          }
        })
        microsoftTranslatev3["userGroups"] = userGroups;
      } else {
        microsoftTranslatev3["userGroups"] = [];
      }
  
      var isPost=false;
      if (microsoftTranslatev3?.id===null || microsoftTranslatev3?.id==='') {
        isPost=true;
     }

      const url = `${APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED('MICROSOFT_TRANSLATE_V3')}`;
      showGlobalOverlay(true);
  
      putOrPostAxiosResponse(url, microsoftTranslatev3,isPost).then((res) => {
        showGlobalOverlay(false);
  
        if (res.data.code === 200) {
          if(res.data.data.statusCodeValue===200){
            setMessage(updateMessage)
          }
          else{
            setMessage(failureMessage)
          }
          getSharedCredentials(Constants.MICROSOFT_TRANSLATE_V3);
        }
        setTimeout(() => {
          setMessage(Constants.BLANK);
      }, 2000);
      }).catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
    }
    else{
      setMessage(translate("cust_vendor.machine_translation_permission"));
      setTimeout(() => {
        setMessage(''); 
    }, 2000); 
    }
   
  }

  const updateMicrosoftTranslateLilt = () => {
    if(liltTranslate!==undefined && access && preference==='LILT_TRANSLATE')
    {
      liltTranslate["credentialsType"] = "LILT_TRANSLATE";
      liltTranslate["credentials"] = {
        "CLIENT_SECRET": liltapikey
      }
      if (selectedDepatmentlilt && selectedDepatmentlilt.length > 0) {
        let userGroups = selectedDepatmentlilt.map(id => {
          return {
            "id": id
          }
        })
        liltTranslate["userGroups"] = userGroups;
      }
      else {
        liltTranslate["userGroups"] = [];
      }
  
      var isPost=false;
      if (liltTranslate?.id===null || liltTranslate?.id==='') {
        isPost=true;
     }

      const url = `${APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED('LILT_TRANSLATE')}`;
      showGlobalOverlay(true);
      putOrPostAxiosResponse(url, liltTranslate,isPost).then((res) => {
        showGlobalOverlay(false);
        if (res.data.code === 200) {
          if(res.data.data.statusCodeValue===200){
            setMessage(updateMessage)
          }
          else{
            setMessage(failureMessage)
          }
         getSharedCredentials(Constants.LILT_TRANSLATE);
        }
        setTimeout(() => {
          setMessage(Constants.BLANK);
      }, 2000);
      }).catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
    }
    else{
      setMessage(translate("cust_vendor.machine_translation_permission"));
      setTimeout(() => {
        setMessage(''); 
    }, 2000); 
    }
    
  }

  function uploadEndHandler(res) {
    if (res.status === 200) {
      if (res.data.data.statusCodeValue === 200) {
        setMessage(updateMessage);
        getSharedCredentials(Constants.GOOGLE_TRANSLATE);
      }
      else {
        setErrorMessage(res.data.data.body.errors.invalid)
        uploadFileRef.current.reset()
        setDisableUpload(true)
      }
    }
  }

  function fileSelection(e) {
    if (e?.target?.files[0]) {
      setDisableUpload(false)
    }
  }
  const fileUploadStart = () => {
    uploadFileRef.current.startUpload();
    setDisableUpload(true);
  }

  const updateMicrosoftTranslateIbm = () => {
    if(ibmTranslate!==undefined && access && preference==='IBM_TRANSLATE')
    {
      ibmTranslate["credentialsType"] = "IBM_TRANSLATE";
      ibmTranslate["credentialCharArray"] = [...ibmcred?.password]
      ibmTranslate["credentials"] =
      {
        "USERNAME": "<a className=\"alt\" target=\"_blank\" href=\"mailto:" + ibmcred?.username + "\" title=\"mailto:" + ibmcred?.username + "\">" + ibmcred?.username + "</a>"
      }
      if (selectedDepatmentibm && selectedDepatmentibm.length > 0) {
        let userGroups = selectedDepatmentibm.map(id => {
          return {
            "id": id
          }
        })
        ibmTranslate["userGroups"] = userGroups;
      }
      else {
        ibmTranslate["userGroups"] = [];
      }

      var isPost=false;
      if (ibmTranslate?.id===null || ibmTranslate?.id==='') {
        isPost=true;
     }
      const url = `${APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED('IBM_TRANSLATE')}`;
      showGlobalOverlay(true);
  
      putOrPostAxiosResponse(url, ibmTranslate,isPost).then((res) => {
        showGlobalOverlay(false);
  
        if (res.data.code === 200) {
          if(res.data.data.statusCodeValue===200){
            setMessage(updateMessage)
          }
          else{
            setMessage(failureMessage)
          }
            getSharedCredentials(Constants.IBM_TRANSLATE);
        }
        setTimeout(() => {
          setMessage(Constants.BLANK);
      }, 2000);
      }).catch((err) => {
        showGlobalOverlay(false);
        handleError(err);
      });
    }
    else{
      setMessage(translate("cust_vendor.machine_translation_permission"));
      setTimeout(() => {
        setMessage(''); 
    }, 2000); 
    }

  }


const updateLanguageWeaver = () => {
  if(languageWeaverTranslate!==undefined && access && preference==='LANG_WEAVER_TRANSLATE')
  {
    languageWeaverTranslate["credentialsType"] = "LANG_WEAVER_TRANSLATE";
    languageWeaverTranslate["credentials"] = {
      "CLIENT_ID": languageWeaverClientID,
      "CLIENT_SECRET":languageWeaverClientSecret
      
    }
    if (selectedDepatmentlWeaver && selectedDepatmentlWeaver?.length > 0) {
      let userGroups = selectedDepatmentlWeaver?.map(id => {
        return {
          "id": id
        }
      })
      languageWeaverTranslate["userGroups"] = userGroups;
    }
    else {
      languageWeaverTranslate["userGroups"] = [];
    }
    var isPost=false;
    if (languageWeaverTranslate?.id===null || languageWeaverTranslate?.id==='') {
      isPost=true;
   }

    const url = `${APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED('LANG_WEAVER_TRANSLATE')}`;
    showGlobalOverlay(true);
    putOrPostAxiosResponse(url, languageWeaverTranslate,isPost).then((res) => {
      showGlobalOverlay(false);
      if (res.data.code === 200) {
        if(res.data.data.statusCodeValue===200){
          setMessage(updateMessage)
        }
        else{
          setMessage(failureMessage)
        }
        getSharedCredentials(Constants.LANG_WEAVER_TRANSLATE);
      }
      setTimeout(() => {
        setMessage(Constants.BLANK);
      }, 2000);
    }).catch((err) => {
      showGlobalOverlay(false);
      handleError(err);
    });
  }
  else{
    setMessage(translate("cust_vendor.machine_translation_permission"));
    setTimeout(() => {
      setMessage(''); 
  }, 2000); 
  }
  
}


  const handleDepartmentChange = (selectedList) => {
    setSelectedDepartment(Array.isArray(selectedList) ? selectedList.map(x => x.value) : []);
  };

  const handleDepartmentChangev3 = (selectedList) => {
    setSelectedDepartmentv3(Array.isArray(selectedList) ? selectedList.map(x => x.value) : []);
  };

  const handleDepartmentChangelilt = (selectedList) => {
    setSelectedDepartmentlilt(Array.isArray(selectedList) ? selectedList.map(x => x.value) : []);
  };

  const handleDepartmentChangeWeaver = (selectedList) => {
    setSelectedDepartmentWeaver(Array.isArray(selectedList) ? selectedList.map(x => x.value) : []);
  };


  const handleDepartmentChangeibm = (selectedList) => {
    setSelectedDepartmentibm(Array.isArray(selectedList) ? selectedList.map(x => x.value) : []);
  };



  const LimitedChipsContainer = ({ children, hasValue, ...props }) => {
    if (!hasValue) {
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );
    }
    var departmentNames = []
    const CHIPS_LIMIT = 20;
    const [chips, otherChildren] = children;
    const overflowCounter1 = chips.length;
    const overflowCounter = chips.slice(CHIPS_LIMIT).length;
    const displayChips = chips.slice(
      overflowCounter,
      overflowCounter + CHIPS_LIMIT
    );
    displayChips.map((chip)=>{
      if(chip.props.children !== 'Check All'){
        departmentNames.push(chip.props.children)
    }
      if(chip.props.children.length === 0){
        departmentNames = 'none'
      }
      
    })
    $(".department-dropdown span:first").attr("aria-label", departmentNames.length + " selected - " + departmentNames + ". Press down arrow key to open the menu and select/unselect options.");
    return (
      <components.ValueContainer {...props}>

        <div id="selected-lang-container" style={{marginTop: "-28px"}} role="status" aria-label={departmentNames + ' selected'} >{overflowCounter1 > 0 && ` ${overflowCounter1 } selected`}</div>

        {otherChildren}
      </components.ValueContainer>
    );
  };

  const IndicatorsContainer = (props) => {
    return (
      <div style={{ marginLeft: "10px" }}>
        <components.IndicatorsContainer {...props} />
      </div>
    );
  };
  const CustomClearText = () => '';
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div {...restInnerProps} ref={ref}>
        {children}
      </div>
    );
  };


  const Option = (props) => {
    return props.data.value !== "all" && props.data.value !== "none" ? (
      <components.Option {...props}>
        <input
          tabIndex={0}
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          id={props.label}
        />{" "}
        <label htmlFor={props.label}>{props.label}</label>
      </components.Option>
    ) : (
      <components.Option {...props}>
        <label
          style={{ fontWeight: 600, fontSize: "14px" }}
          htmlFor={props.label}
        >
          {props.label}
        </label>
        <button
          style={{
            fontWeight: 600,
            fontSize: "14px",
            display: "none",
            color: aaaSelected ? "#fff" : "#000",
          }}
          aria-label={props.label}
        >
          {" "}
          {props.label}{" "}
        </button>
      </components.Option>
    );
  };

  useEffect(() => {
    getAllProjectOwner()
    getAllDepartment();
    getCustomerPreference();
    getSharedCredentials(Constants.LILT_TRANSLATE);
    getSharedCredentials(Constants.IBM_TRANSLATE);
    getSharedCredentials(Constants.GOOGLE_TRANSLATE);
    getSharedCredentials(Constants.MICROSOFT_TRANSLATE);
    getSharedCredentials(Constants.MICROSOFT_TRANSLATE_V3);
    getSharedCredentials(Constants.LANG_WEAVER_TRANSLATE);
  }, [])


  useEffect(() => {
    if (microsoftTranslate && microsoftTranslate?.userGroups) {
      setSelectedDepartment(microsoftTranslate.userGroups.map(obj => obj.id));
    }
  }, [microsoftTranslate])

  useEffect(() => {
    if (microsoftTranslatev3 && microsoftTranslatev3?.userGroups) {
      setSelectedDepartmentv3(microsoftTranslatev3?.userGroups.map(obj => obj.id));
    }
  }, [microsoftTranslatev3])

  useEffect(() => {
    if (ibmTranslate && ibmTranslate?.userGroups) {
      setSelectedDepartmentibm(ibmTranslate.userGroups.map(obj => obj.id));
    }
  }, [ibmTranslate])

  useEffect(() => {
    if (liltTranslate && liltTranslate?.userGroups) {
      setSelectedDepartmentlilt(liltTranslate?.userGroups.map(obj => obj.id));
    }
  }, [liltTranslate])

  useEffect(() => {
    if (languageWeaverTranslate && languageWeaverTranslate?.userGroups) {
      setSelectedDepartmentWeaver(languageWeaverTranslate?.userGroups?.map(obj => obj?.id));
    }
  }, [languageWeaverTranslate])

  useEffect(() => {
    if (googleTranslate && googleTranslate?.userGroups) {
      setSelectedDepartmentWeaver(googleTranslate?.userGroups?.map(obj => obj?.id));
    }
  }, [googleTranslate])


  const clopseExpandAccordion = (accordion) => {
    if (accordion.hasClass("open")) {
      accordion.removeClass("open")
    } else {
      accordion.addClass("open")
    }
  }

  const getSharedCredentials = (service) => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED(service) + `?_=${dateTimestamp}`
    ).then(res => {
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        switch (service) {
          case Constants.LILT_TRANSLATE:
            setLiltTranslate(credentialsSet)
            break;
          case Constants.IBM_TRANSLATE:
            setIbmTranslate(credentialsSet)
            break;
          case Constants.GOOGLE_TRANSLATE:
            setGoogleTranslate(credentialsSet)
            break;
          case Constants.MICROSOFT_TRANSLATE:
            setMicrosoftTranslate(credentialsSet)
            break;
          case Constants.MICROSOFT_TRANSLATE_V3:
            setMicrosoftTranslatev3(credentialsSet)
            break;
          case Constants.LANG_WEAVER_TRANSLATE:
            setlanguageWeaverTranslate(credentialsSet)
            break;
           default:
            break;

        }
      }
      setMessage(Constants.BLANK)

    }).catch(err => {
      setMessage(Constants.BLANK)
      handleError(err);
    });
  };


  const getAllProjectOwner = async () => {
    showGlobalOverlay(true);

    getAxiosResponse(APIUrls.CAMPAIGN_OWNER)
      .then((result) => {
        showGlobalOverlay(false);

        if (result.data.data && result.data.data.length > 0) {
          setProjectowners(transformBlankToNull(result.data.data))
        }
      })
      .catch((err) => {
        showGlobalOverlay(false);

        handleError(err);
      });
  }

  const getAllDepartment = async () => {
    await getAxiosResponse(APIUrls.DEPARTMENT_URL)
      .then((res) => {
        if (res.data.code === 200) {
          const options = res.data.data.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          if(options && options.length>0){
            options.unshift(
              {
                label: translate("task_campaign.check_all"),
                value: "all",
              })
              options.unshift(
                {
                  label: translate("task_campaign.uncheck_all"),
                  value: "none",
                })
            setDepartments(options);
          }
          else{

            getAxiosResponse(APIUrls.ALL_DEPARTMENT)
            .then((res) => {
              const options = res?.data?.data?.map(({ id, name }) => ({
                label: name,
                value: id,
              }));
              setDepartments(options);
            })
            .catch((err) => {
              handleError(err);
            });
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }

  const getCustomerPreference = () => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_ORG_PREFERENCE + `?preference=ENGINE_LIST_FOR_MACHINE_TRANSLATION&_=${dateTimestamp}`
    ).then((res) => {
      if (res.data.code === 200) {
        
          setPreference(res.data.data.status);
         
      }
    }).catch((err) => {
      handleError(err);
    });
  }

  const updateMTPermission = (owner, status) => {
    if (owner) {
      owner.permissions['MACHINE_TRANSLATION_ACCESS'] = status;
    }
    if(owner.userId===LoggedInUserId)
    {
       setAccess(owner.permissions['MACHINE_TRANSLATION_ACCESS']);
      // Save the access state in sessionStorage
      sessionStorage.setItem('machineTranslationAccess', owner.permissions['MACHINE_TRANSLATION_ACCESS']);
    }
    const url = `${APIUrls.UPDATE_MACHINE_TRANSLATION_ACCESS(
      owner.userId, 'MICROSOFT_TRANSLATE'
    )}`;
    showGlobalOverlay(true);

    postAxiosResponse(url, owner).then((res) => {
      showGlobalOverlay(false);

      if (res.data.code === 200) {
        getAllProjectOwner();
      }

    }).catch((err) => {
      showGlobalOverlay(false);
      handleError(err);
    });


  }

  const handleInputChange = (e) => {
    if(e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  }

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Machine Translation', url:''},
   ]; 

   useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  useEffect(() => {
    // Retrieve the stored value from sessionStorage and set the initial state
    const initialAccess = sessionStorage.getItem('machineTranslationAccess') || 'defaultAccessValue';
    setAccess(initialAccess);
  }, []);
 
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} >
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button aria-label="back" onClick={() => navigate('/settings')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                      <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8" />
                    </svg>
                  </button>
                  <span>Back to Settings</span>
                </div>
                <h3 className="flex">Machine Translation</h3>
                <span>Instantly translate your content using a machine translation engine.
                  <br />
                  OPAL-Marketing will sync all of your Translation Memory with the machine translation provider, ensuring your translations match previously-translated content.
                </span>
              </div>
              <div className="white-bg">
                <div className="integration-tab-content marketo-integration-accordion">
                  <div id="machine-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex active">
                      <div className="left">
                        <strong>Permission to Use Machine Translation</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#machine-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <p>Manage who has permission to create machine translation projects in OPAL-Marketing.</p>
                      <div className="table-responsive global-table">
                        <table className="sortable">
                          <thead>
                            <th>Name</th>
                            <th>Role</th>
                            <th>Department</th>
                            <th>Access to Machine Translation</th>
                          </thead>
                          <tbody>
                            {
                              projectowners && projectowners.length > 0 && projectowners.map((owner, index) => (

                                <tr key={index}>
                                  <td>{owner.firstName} &nbsp; {owner.lastName}</td>
                                  <td>{owner?.roleSet?.displayName}</td>
                                  <td>
                                    {
                                      owner?.userGroupMembers?.length > 2 ?
                                        <>
                                          <span>
                                            {owner?.userGroupMembers?.slice(0, 2).map((group) => (
                                              group?.userGroup?.name + ", "
                                            )
                                            )
                                            }
                                          </span>
                                          <a href="#" onClick={() => showModel(owner?.userGroupMembers)}> + {owner?.userGroupMembers?.length - 2}</a>

                                        </> :
                                        owner?.userGroupMembers?.map((group) => (
                                          group?.userGroup?.name + ", "
                                        )
                                        )
                                    }


                                  </td>
                                  <td>
                                    <div className="flex-center gap-10"  >
                                      <div className="yes-no-customradio" >
                                        <input type="radio" className="form-check-input" onClick={() => updateMTPermission(owner, true)} name={`radio${owner.userId}`} id={`rdyes${owner.userId}`} defaultChecked={owner?.permissions?.MACHINE_TRANSLATION_ACCESS === true} />
                                        <label className="form-check-label" htmlFor={`rdyes${owner.userId}`}>Yes</label>
                                      </div>
                                      <div className="yes-no-customradio">
                                        <input type="radio" className="form-check-input" onClick={() => updateMTPermission(owner, false)} name={`radio${owner.userId}`} id={`rdno${owner.userId}`} defaultChecked={owner?.permissions?.MACHINE_TRANSLATION_ACCESS === false} />
                                        <label className="form-check-label" htmlFor={`rdno${owner.userId}`}>No</label>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            }



                          </tbody>
                        </table>
                      </div>
                      {/* <div className="flex flex-end mar-top30">
                           <button className="blue-btn active">Save</button>
                        </div> */}
                    </div>
                  </div>
                  <div id="microsoft-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>Microsoft Translator API Settings</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#microsoft-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">Microsoft Translator API Settings</h6>
                      <p className="f14-para mb-0">Enter your Microsoft Translator account information to activate machine translation for your projects.</p>
                      <p className="f14-para">To find this information, go to My Account in the Microsoft Azure Marketplace.</p>
                      <div className="flex wrap-dropdown flex-column mar-bot20">
                        <div className="global-dropdown-block global-multidropdown-check flex-center">
                          <label>Select Departments for Machine Translation</label>
                          <div className="global-dropdown-select " ref={selectRef} >
    
                          <Select
                            classNamePrefix="cw"
                            ref={multiSelectRef}
                            className="global-dropdown-select"
                            value={departments.filter(obj => selectedDepatment.includes(obj.value))}
                            aria-label="Departments"
                            isMulti
                            allowSelectAll={true}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            options={departments?.length === 2 ? departments?.slice(2) : departments } 
                            onChange={(selected) => {
                              selected.length &&
                              selected.find((option) => option.value === "all")
                                ? handleDepartmentChange(departments.slice(2))
                                : selected.find((option) => option.value === "none") 
                                ? handleDepartmentChange([])
                                : handleDepartmentChange(selected);
                            }}

                            components={{
                              ValueContainer: LimitedChipsContainer,
                              Option,
                              ClearIndicator,
                              IndicatorsContainer,
                            }}
                          />
                        </div>
                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>
                      <div className="wrap-input-text-group mar-bot20">
                        <label>Microsoft Azure Key</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setClientSecret(e.target.value)} value={clientSecret} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>
                      <div className="flex flex-end mar-top20">
                        <button onClick={updateMicrosoftTranslate} className="blue-btn active">Save</button>
                      </div>
                    </div>
                  </div>
                  <div id="microsoft-translation-v3-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>Microsoft Translator API V3 Settings</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#microsoft-translation-v3-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">Microsoft Translator v3 API Settings</h6>
                      <p className="f14-para mb-0">Enter your Microsoft Translator account information to activate machine translation for your projects.</p>
                      <p className="f14-para">To find this information, go to My Account in the Microsoft Azure Marketplace.</p>
                      <div className="flex wrap-dropdown flex-column mar-bot20">
                      <div className="global-dropdown-block global-multidropdown-check flex-center">
                          <label>Select Departments for Machine Translation</label>

                          <div className="global-dropdown-select " ref={selectRef} >

                          <Select
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            value={departments.filter(obj => selectedDepatmentv3.includes(obj.value))}
                            aria-label="Departments"
                            isMulti
                            allowSelectAll={true}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            options={departments?.length === 2 ? departments?.slice(2) : departments } 
                            onChange={(selected) => {
                              selected.length &&
                              selected.find((option) => option.value === "all")
                                ? handleDepartmentChangev3(departments.slice(2))
                                : selected.find((option) => option.value === "none") 
                                ? handleDepartmentChangev3([])
                                : handleDepartmentChangev3(selected);
                            }}

                            components={{
                              ValueContainer: LimitedChipsContainer,
                              Option,
                              ClearIndicator,
                              IndicatorsContainer,
                            }}
                          /></div>

                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>
                      <div className="wrap-input-text-group mar-bot20">
                        <label>Microsoft Azure Key</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setMicrosoftv3({ ...microsoftv3, clientSecret: e.target.value })} value={microsoftv3?.clientSecret} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>


                      <div className="flex wrap-dropdown flex-column mar-bot20">
                        <div className="global-dropdown-block">
                          <label>Default engine</label>


                          <Select
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            defaultValue={engineOptions[0]}
                            onChange={(e) => setMicrosoftv3({ ...microsoftv3, defaultEngine: e.value })}
                            name="color"
                            options={engineOptions}
                          />


                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>

                      <div className="wrap-input-text-group mar-bot20">
                        <label>Language pair setting</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setMicrosoftv3({ ...microsoftv3, languagePair: e.target.value })} value={microsoftv3?.languagePair} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>

                      <div className="flex flex-end mar-top20">
                        <button onClick={updateMicrosoftTranslateV3} className="blue-btn active">Save</button>
                      </div>
                    </div>
                  </div>




                  <div id="lilt-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>Lilt Translator API Settings</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#lilt-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">Lilt Translator API Settings</h6>
                      <p className="f14-para mb-0">Enter your Lilt Translator account information to activate machine translation for your projects.</p>
                      <div className="flex wrap-dropdown flex-column mar-bot20">
                      <div className="global-dropdown-block global-multidropdown-check flex-center">
                          <label>Select Departments for Machine Translation</label>

                          <div className="global-dropdown-select " ref={selectRef} >

                          <Select
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            value={departments.filter(obj => selectedDepatmentlilt.includes(obj.value))}
                            aria-label="Departments"
                            isMulti
                            allowSelectAll={true}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            options={departments?.length === 2 ? departments?.slice(2) : departments } 
                            onChange={(selected) => {
                              selected.length &&
                              selected.find((option) => option.value === "all")
                                ? handleDepartmentChangelilt(departments.slice(2))
                                : selected.find((option) => option.value === "none") 
                                ? handleDepartmentChangelilt([])
                                : handleDepartmentChangelilt(selected);
                            }}
                            components={{
                              ValueContainer: LimitedChipsContainer,
                              Option,
                              ClearIndicator,
                              IndicatorsContainer,
                            }}
                          />
                          </div>

                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>
                      <div className="wrap-input-text-group mar-bot20">
                        <label>Lilt API Key</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setLiltapikey(e.target.value)} value={liltapikey} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>
                      <div className="flex flex-end mar-top20">
                        <button onClick={updateMicrosoftTranslateLilt} className="blue-btn active">Save</button>
                      </div>
                    </div>
                  </div>


                  <div id="google-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>Google Translate API keys</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#google-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">Google Translator API Settings</h6>
                      <div className="wrap-input-text-group mar-bot20">
                        <div className="input-text-group flex">
                          <FileDragUpload ref={uploadFileRef}
                            onChange={fileSelection}
                            fileDataAttribute="credentialsJson"
                            uploadUrl={APIUrls.MACHINE_TRANSLATION_CREDENTIALS_SHARED_FOR_GOOGLE('GOOGLE_TRANSLATE')}
                            uploadEndHandler={uploadEndHandler}>
                            <p id="descriptionHeader">Upload the JSON file provided by Google Cloud Platform. You have not yet uploaded credentials for this service.</p>
                          </FileDragUpload>
                        </div>
                        <button onClick={fileUploadStart} disabled={disableUpload} className="blue-btn active">Upload</button>

                      </div>

                      <div className="error-alert failed">
                        {(errorMessage !== undefined && errorMessage !== Constants.BLANK) ? <ErrorMessage message={errorMessage} /> : Constants.BLANK}
                      </div>
                    </div>
                  </div>


                  <div id="ibm-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>IBM Translator API Settings</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#ibm-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">IBM Translator API Settings</h6>
                      <p className="f14-para mb-0">Enter your IBM Translator account information to activate machine translation for your projects.</p>
                      <div className="flex wrap-dropdown flex-column mar-bot20">
                      <div className="global-dropdown-block global-multidropdown-check flex-center">
                          <label>Select Departments for Machine Translation</label>
                          <div className="global-dropdown-select " ref={selectRef} >


                          <Select
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            value={departments.filter(obj => selectedDepatmentibm.includes(obj.value))}
                            aria-label="Departments"
                            isMulti
                            allowSelectAll={true}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            options={departments?.length === 2 ? departments?.slice(2) : departments } 

                            onChange={(selected) => {
                              selected.length &&
                              selected.find((option) => option.value === "all")
                                ? handleDepartmentChangeibm(departments.slice(2))
                                : selected.find((option) => option.value === "none") 
                                ? handleDepartmentChangeibm([])
                                : handleDepartmentChangeibm(selected);
                            }}

                            components={{
                              ValueContainer: LimitedChipsContainer,
                              Option,
                              ClearIndicator,
                              IndicatorsContainer,
                            }}
                          />
                          </div>
                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>
                      <div className="wrap-input-text-group mar-bot20">
                        <label>Username</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setIbmcred({ ...ibmcred, username: e.target.value })} value={ibmcred?.username} type="text" className="form-control-sm" placeholder="**********" />

                        </div>
                      </div>

                      <div className="wrap-input-text-group mar-bot20">
                        <label>Password</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setIbmcred({ ...ibmcred, password: e.target.value })} value={ibmcred?.password} type="password" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>

                      <div className="flex flex-end mar-top20">
                        <button onClick={updateMicrosoftTranslateIbm} className="blue-btn active">Save</button>
                      </div>
                    </div>
                  </div>



                  <div id="weaver-translation-accordion" className="integration-accordion-list open">
                    <div className="accordion-heading flex">
                      <div className="left">
                        <strong>Language Weaver Translator API Settings</strong>
                      </div>
                      <div className="right" onClick={() => clopseExpandAccordion(jQuery("#weaver-translation-accordion"))}>
                        <svg className="plus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="12.2773" y="6.5" width="1.44444" height="13" rx="0.722222" fill="#1D4ED8" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                        <svg className="minus-circle" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                          <circle cx="13" cy="13" r="12.3" fill="#F9FBFF" stroke="#1D4ED8" strokeWidth="1.4" />
                          <rect x="6.5" y="13.7227" width="1.44444" height="13" rx="0.722222" transform="rotate(-90 6.5 13.7227)" fill="#1D4ED8" />
                        </svg>
                      </div>
                    </div>
                    <div className="integration-accordion-content">
                      <h6 className="mar-bot10">Language Weaver Translator API Settings</h6>
                      <p className="f14-para mb-0">Enter your Language Weaver  Translator account information to activate machine translation for your projects.</p>
                      <div className="flex wrap-dropdown flex-column mar-bot20">
                      <div className="global-dropdown-block global-multidropdown-check flex-center">
                          <label>Select Departments for Machine Translation</label>

                          <div className="global-dropdown-select " ref={selectRef} >

                          <Select
                            classNamePrefix="cw"
                            className="global-dropdown-select"
                            value={departments?.filter(obj => selectedDepatmentlWeaver?.includes(obj?.value))}
                            aria-label="Departments"
                            isMulti
                            allowSelectAll={true}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            options={departments?.length === 2 ? departments?.slice(2) : departments } 
                            onChange={(selected) => {
                              selected.length &&
                              selected.find((option) => option.value === "all")
                                ? handleDepartmentChangeWeaver(departments?.slice(2))
                                : selected.find((option) => option.value === "none") 
                                ? handleDepartmentChangeWeaver([])
                                : handleDepartmentChangeWeaver(selected);
                            }}
                            components={{
                              ValueContainer: LimitedChipsContainer,
                              Option,
                              ClearIndicator,
                              IndicatorsContainer,
                            }}
                          />
                          </div>

                        </div>
                        <div className="multiselect-output flex max-680">


                        </div>
                      </div>
                      <div className="wrap-input-text-group mar-bot20">
                        <label>Client ID</label>
                        <div className="input-text-group flex">
                          <input onChange={(e) => setlanguageWeaverClientID(e.target.value)} value={languageWeaverClientID} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                        <label>Client Secret</label>

                        <div className="input-text-group flex">
                          <input onChange={(e) => setlanguageWeaverClientSecret(e.target.value)} value={languageWeaverClientSecret} type="text" className="form-control-sm" placeholder="**********" />
                        </div>
                      </div>
                      <div className="flex flex-end mar-top20">
                        <button onClick={updateLanguageWeaver} className="blue-btn active">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="lightbox-panel target-lang-popup">
        <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex padd-lr">
            <strong>Departments</strong>
            <button className="close" aria-label="close right popup" onClick={hideModel}>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path>
                <path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path>
              </svg>
            </button>
          </div>
          <div className="lightbox-content">
            <div className="gb-gray-list">
              <ul>
                {departmentModel?.map((group) => (
                  <li>{group?.userGroup?.name}</li>

                )
                )
                }

              </ul>
            </div>
          </div>

        </div>
      </div>

      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>

      {(message!==undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}


    </div>
  );
}
